import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";

/**
 * Shared section header used across all internal pages (Clientes, Catálogos,
 * Análise de Vendas, PPM, Promoção, etc). Guarantees the exact same title
 * font size, the exact same back arrow (web + mobile), and consistent icon
 * placement/size wherever an icon is used.
 */
export const PageHeader = ({ icon: Icon, title, subtitle, actions, onBack }) => {
  const navigate = useNavigate();
  return (
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 sm:gap-4">
      <div className="flex items-center gap-2 min-w-0">
        <button
          type="button"
          onClick={onBack || (() => navigate(-1))}
          className="p-2 -ml-2 text-stone-500 dark:text-stone-400 hover:text-[#009392] hover:bg-stone-100 dark:hover:bg-stone-800 rounded-lg transition-colors flex-shrink-0"
          data-testid="btn-page-back"
          aria-label="Voltar"
        >
          <ArrowLeft size={22} weight="bold" />
        </button>
        <div className="min-w-0">
          <h1 className="text-2xl font-bold font-[Manrope] text-stone-900 dark:text-white flex items-center gap-2 min-w-0">
            {Icon && <Icon size={24} weight="duotone" className="text-[#009392] flex-shrink-0" />}
            <span className="truncate">{title}</span>
          </h1>
          {subtitle && <p className="text-sm text-stone-500 dark:text-stone-400 mt-0.5 truncate">{subtitle}</p>}
        </div>
      </div>
      {actions && <div className="flex-shrink-0 flex gap-2 flex-wrap">{actions}</div>}
    </div>
  );
};
